module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-03-1d5a3c74e89321c82ff547160ee26afa.svg";